import React from "react";
import InputSkeletonGroup from "../../Common/Loaders/InputSkeleton";
import InputSkeletonLogo from "../../Common/Loaders/InputSkeletonLogo";

const TransactionDetailsSkeletonLoader = ({ loading }: { loading: boolean }) => {
  if (!loading) return null;

  return (
    <div className="transaction-details-skeleton-loader" data-testid="transaction-details-skeleton-loader">
      <div className="skeleton-header">
        <InputSkeletonLogo />
        <InputSkeletonGroup numInputs={2} hideLabels={true} direction="vertical" />

      </div>
      <div className="skeleton-body">
        <InputSkeletonGroup numInputs={5} hideLabels={true} direction="vertical" />
      </div>
    </div>
  );
}

export default TransactionDetailsSkeletonLoader;